module.exports = __webpack_public_path__ + "static/kristiina_ronnberg-17963bff25a3d275e1287eb327b9d984.jpg";